import type { AirportCodes, DashboardTabSettings } from './types'
import { DashboardWidgetId } from './widgetCatalogue'

export interface DashboardTabDefinition {
    id: string
    widgets: DashboardWidgetId[]
}

export const BUILT_IN_DASHBOARD_TABS: readonly DashboardTabDefinition[] = [
    { id: 'events', widgets: [DashboardWidgetId.Events, DashboardWidgetId.NewsFeed] },
    {
        id: 'operations',
        widgets: [
            DashboardWidgetId.OperationalForecast,
            DashboardWidgetId.Flights,
            DashboardWidgetId.Runways,
            DashboardWidgetId.Delays,
            DashboardWidgetId.Punctuality,
            DashboardWidgetId.Regularity,
            DashboardWidgetId.Cdm,
        ],
    },
    {
        id: 'passengers',
        widgets: [
            DashboardWidgetId.QueueingTimeSecurity,
            DashboardWidgetId.QueueingTimeBorder,
            DashboardWidgetId.PaxForecast,
            DashboardWidgetId.Pax,
        ],
    },
    { id: 'weather', widgets: [DashboardWidgetId.WeatherForecast, DashboardWidgetId.Weather] },
    { id: 'baggage', widgets: [DashboardWidgetId.BaggageDelivery] },
]

export const RESERVED_TAB_IDS: readonly string[] = ['overview', 'my-dashboard']

export const TAB_ID_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/

export const TAB_TRANSLATION_NAMESPACE = 'dashboard'

export const tabTranslationKey = (tabId: string): string => `tab.${tabId}`

export const createDefaultDashboardTabs = (airports: AirportCodes): DashboardTabSettings[] =>
    BUILT_IN_DASHBOARD_TABS.map(tab => ({
        id: tab.id,
        airports: [...airports],
        widgets: [...tab.widgets],
    }))
